import React from 'react'
import AppStoreDownloadItem from '../component/AppStoreDownloadItem/AppStoreDownloadItem'

import QuoteSection from '../component/QuoteSection/QuoteSection'
import './EaseAppsInfoComponent.css'

import EaseStarLogo from '../../../assets/logos/easestar.png'

function EaseStarInfoComponent() {
  return (
    <div className="ease-star-info">
      <QuoteSection
        quoteText="EaseStar isn't just a social app. It's a statement on how privacy and creativity can coexist beautifully."
        quoteAuthor="App Creators"
      />

      <section>
        <h4>An App Built for Sharing, Privacy, and Community</h4>
        <p>
          EaseStar was born out of a desire to create a safe and creative space
          for sharing. Unlike any other social app, it takes user privacy
          seriously while embracing global connectivity through automatic
          translation and rich multimedia sharing.
        </p>
        <ul>
          <li>
            <strong>Privacy First:</strong> EaseStar ensures images you upload
            cannot be downloaded or screenshotted without your permission. Your
            content is yours to control, whether it’s text, photos, or art.
          </li>
          <li>
            <strong>Multilingual Content:</strong> With built-in automatic
            translation, posts are seamlessly translated into Chinese and
            English, making the app a truly global platform for connecting with
            diverse audiences.
          </li>
          <li>
            <strong>Creative Expression:</strong> Whether you’re sharing
            artwork, photos, or thoughts, EaseStar’s features enable creativity
            to shine while keeping your content secure.
          </li>
        </ul>
      </section>
      <section>
        <h4>Smart Features That Simplify and Enhance Your Social Experience</h4>
        <ul>
          <li>
            <strong>Anonymous Mode:</strong> Post and interact anonymously with
            the name “Earthonline NPC” when you want your voice to blend into
            the crowd.
          </li>
          <li>
            <strong>Pinned Posts:</strong> Highlight your favorite post on your
            profile for all to see. Change or unpin it whenever you like.
          </li>
          <li>
            <strong>Custom Frames for Profiles:</strong> Earn points through
            your interactions and redeem them for unique profile frames that
            reflect your style.
          </li>
          <li>
            <strong>Effortless Grouping:</strong> Posts are categorized into
            easy-to-navigate sections like art, travel, food, and technology, so
            your feed stays relevant to your interests.
          </li>
        </ul>
      </section>
      <footer>
        <h4>Ready to Join the Community?</h4>
        <p>
          Start your journey with EaseStar today. Share your creativity, protect
          your privacy, and connect with a global audience on a platform that
          puts users first.
        </p>
        <AppStoreDownloadItem
          appName="EaseStar"
          description="Edit, manage and share posts"
          buttonText="Get"
          logoSrc={EaseStarLogo}
          url="https://apps.apple.com/us/app/easestar/id6471627227"
        />
      </footer>
    </div>
  )
}

export default EaseStarInfoComponent
